import React from 'react';
import {
    ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { fmtMoneyCompact, fmtMoney, fmtPct } from '../utils/format';

const tooltipFormatter = (value, name) => {
    if (name === 'Net Margin %' || name === 'Gross Margin %') return [fmtPct(value), name];
    return [fmtMoney(value), name];
};

const TrendChart = ({ data, title, subtitle }) => {
    if (!data || !data.length) return null;

    return (
        <div className="fr-card">
            <div className="fr-card-header">
                <h3>{title}</h3>
                {subtitle && <p>{subtitle}</p>}
            </div>
            <div className="fr-chart-wrap">
                <ResponsiveContainer width="100%" height={360}>
                    <ComposedChart data={data} margin={{ top: 20, right: 30, left: 10, bottom: 10 }}>
                        <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" />
                        <XAxis dataKey="label" tick={{ fontSize: 12 }} />
                        <YAxis yAxisId="left" tickFormatter={fmtMoneyCompact} tick={{ fontSize: 11 }} />
                        <YAxis yAxisId="right" orientation="right" tickFormatter={(v) => `${v}%`} tick={{ fontSize: 11 }} />
                        <Tooltip formatter={tooltipFormatter} />
                        <Legend wrapperStyle={{ fontSize: 12 }} />
                        <Bar  yAxisId="left" dataKey="sales"           fill="#0ea5e9" name="Sales" />
                        <Bar  yAxisId="left" dataKey="directExpenses"  fill="#f97316" name="Direct Expenses" />
                        <Bar  yAxisId="left" dataKey="indirectExpenses" fill="#ef4444" name="Indirect Expenses" />
                        <Line yAxisId="left" type="monotone" dataKey="netProfit" stroke="#16a34a" strokeWidth={2.5} name="Net Profit" dot={{ r: 4 }} />
                        <Line yAxisId="right" type="monotone" dataKey="netMargin"  stroke="#7c3aed" strokeWidth={2} strokeDasharray="4 4" name="Net Margin %" dot={{ r: 3 }} />
                    </ComposedChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default TrendChart;
